module.exports = __webpack_public_path__ + "img/shop.b149109a.png";